
// ABOUTME: Payments page with URL routing support
// ABOUTME: Displays payment tracking and performance incentive information

import React from 'react';
import Payments from '@/components/payments/Payments';

const PaymentsPage = () => {
  return <Payments />;
};

export default PaymentsPage;
